import { Box, Divider, Group, Text, Tooltip } from '@mantine/core';

import ProductBadge from '../components/ProductBadge';
import type { VendorAvailabilityData, VendorAvailabilityListItem } from '../types';
import StoreAvatar from './AvailabilityCalendar.store-avatar';
import StatusBadge from './AvailabilityCalendar.status-badge';

// Ops says a restaurant realistically serves no more than 6 markets; the backend applies
// no cap, so we truncate the display here and surface the rest via a "+N more" tooltip.
const MAX_VISIBLE_MARKETS = 6;

type RestaurantHeaderProps = {
  restaurant: VendorAvailabilityListItem;
  data: VendorAvailabilityData;
};

const RestaurantHeader: React.FC<RestaurantHeaderProps> = ({ restaurant, data }) => {
  const { markets } = restaurant;
  const visibleMarkets = markets.slice(0, MAX_VISIBLE_MARKETS);
  const hiddenMarkets = markets.slice(MAX_VISIBLE_MARKETS);

  return (
    <Box>
      <Group justify="space-between" wrap="nowrap" px="lg" py="sm">
        <Group gap="sm" wrap="nowrap">
          <StoreAvatar />
          <Box>
            <Text fw={700} c="black">
              {restaurant.internalName}
            </Text>

            <Group gap="xs" align="center">
              <ProductBadge productType={restaurant.productType} />
              <Text component="div" fw={600} c="gray.7" fz={12}>
                Markets: {visibleMarkets.join(', ')}
                {hiddenMarkets.length > 0 && (
                  <Tooltip
                    label={hiddenMarkets.join(', ')}
                    withArrow
                    events={{ hover: true, focus: true, touch: false }}
                  >
                    <Text
                      component="span"
                      fw={700}
                      tabIndex={0}
                      style={{ cursor: 'default' }}
                    >
                      {' '}
                      +{hiddenMarkets.length} more
                    </Text>
                  </Tooltip>
                )}
              </Text>
            </Group>
          </Box>
        </Group>
        <StatusBadge restaurant={restaurant} vendorAvailabilityData={data} />
      </Group>
      <Divider />
    </Box>
  );
};

export default RestaurantHeader;
